import { useGetRolesNew } from "@vega-api/generated/auth-permission-v1/auth-permission-v1";
import { type RoleNew } from "@vega-api/generated/types/roleNew";

import {
  type FundVehicleTab,
  getRoleOptionsForFundVehicleTab,
} from "../components/collaboratorsV2Constants";

export const useCollaboratorRoles = () => {
  const { data: rolesResponse, isLoading } = useGetRolesNew();

  const roles = rolesResponse?.data ?? [];

  const getRoleById = (roleId: string): RoleNew | undefined =>
    roles.find((role) => role.id === roleId);

  const getRoleOptionsForTab = (tab: FundVehicleTab) =>
    getRoleOptionsForFundVehicleTab(roles, tab);

  return { roles, isLoading, getRoleById, getRoleOptionsForTab };
};
